<template>
    <div id="piechart" :style="{ height: '100%'}">

    </div>
</template>
<script >
import { cmsSysCloudlsdCountCountry ,cmsSysCloudlsdAreaSalesAmountfindAllPage} from '../../../../api/home.js'
export default {
    name: "",
    components: {},
        props: ['intervalRefreshDate'],

    data() {
        return {
            timer:null, //定义一个刷新的timer

        };
    },
    watch: {},
    computed: {},
    methods: {
        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('piechart'))
            // 绘制图表
            var data = []
            try {
                //区域销售占比-左上

                const res = await cmsSysCloudlsdAreaSalesAmountfindAllPage({
                    pageNum: 1,
                    pageSize: 6
                })
                console.log(res.data.records)
                // const res = await cmsSysCloudlsdCountCountry()
                res.data.records.forEach((item, index) => {
                    const { countryName, proportion } = item;
                    data.push({ name: countryName, value: Number(proportion.split('%')[0]) })

                })
            } catch (err) {
                this.$message.error("数据加载失败")
                
            }


            // data = [
            //     {
            //         name: '美国',
            //         value: 51,
            //     }, {
            //         name: '英国',
            //         value: 44
            //     }, {
            //         name: '法国',
            //         value: 35
            //     }, {
            //         name: '俄罗斯',
            //         value: 30
            //     }, {
            //         name: '新加坡',
            //         value: 20
            //     },
            //     {
            //         name: '意大利',
            //         value: 20
            //     }
            // ]

            var titleArr = [], seriesArr = [];
            let colors = [
                ['#4670FD', '#132457'],
                ['#3BA3D4', '#103049'], ['#48E5C5', '#1C5156'], ['#F79F4A', '#32261F'], ['#C43653', '#3A1734'], ['#5634E3', '#17194D']]
            data.slice(0, 3).forEach(function (item, index) {
                titleArr.push(
                    {
                        text: item.name,
                        left: index * 35 + 12 + '%',
                        top: '45%',
                        textAlign: 'center',
                        textStyle: {
                            fontWeight: 'normal',
                            fontSize: '16',
                            color: '#fff',
                            textAlign: 'center',
                        },
                    }
                );
                seriesArr.push(
                    {
                        name: item.name,
                        type: 'pie',
                        clockWise: false,
                        radius: [35, 40],
                        itemStyle: {
                            normal: {
                                color: colors[index][0],
                                shadowColor: colors[index][0],
                                shadowBlur: 0,
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                },
                            }
                        },
                        hoverAnimation: false,
                        center: [index * 35 + 14 + '%', '35%'],
                        data: [{
                            value: item.value,
                            label: {
                                normal: {
                                    formatter: function (params) {
                                        return params.value + '%';
                                    },
                                    position: 'center',
                                    show: true,
                                    textStyle: {
                                        fontSize: '20',
                                        fontWeight: 'bold',
                                        color: '#fff'
                                    }
                                }
                            },
                        }, {
                            value: 100 - item.value,
                            name: 'invisible',
                            itemStyle: {
                                normal: {
                                    color: colors[index][1]
                                },
                                emphasis: {
                                    color: colors[index][1]
                                }
                            }
                        }]
                    }
                )
            });

            data.slice(3).forEach(function (item, index) {
                titleArr.push(
                    {
                        text: item.name,
                        left: index * 35 + 13 + '%',
                        top: '82%',
                        textAlign: 'center',
                        textStyle: {
                            fontWeight: 'normal',
                            fontSize: '16',
                            color: '#fff',
                            textAlign: 'center',
                        },
                    }
                );
                seriesArr.push(
                    {
                        name: item.name,
                        type: 'pie',
                        clockWise: false,
                        radius: [35, 40],
                        itemStyle: {
                            normal: {
                                color: colors[3 + index][0],
                                shadowColor: colors[3 + index][0],
                                shadowBlur: 0,
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                },
                            }
                        },
                        hoverAnimation: false,
                        center: [index * 35 + 14 + '%', '72%'],
                        data: [{
                            value: item.value,
                            label: {
                                normal: {
                                    formatter: function (params) {
                                        return params.value + '%';
                                    },
                                    position: 'center',
                                    show: true,
                                    textStyle: {
                                        fontSize: '20',
                                        fontWeight: 'bold',
                                        color: '#fff'
                                    }
                                }
                            },
                        }, {
                            value: 100 - item.value,
                            name: 'invisible',
                            itemStyle: {
                                normal: {
                                    color: colors[3 + index][1]
                                },
                                emphasis: {
                                    color: colors[3 + index][1]
                                }
                            }
                        }]
                    }
                )
            });

            titleArr.push({
                text: `{a|      综试区出口商品销往到各国家的占比情况}`,
                left: '5%',
                top: '8%',
                textAlign: 'left',
                textStyle: {
                    fontWeight: 'normal',
                    fontSize: '12',
                    color: '#9FB7DF',
                    textAlign: 'center',
                    lineHeight: 20,

                    rich: {
                        a: {
                            color: '#9FB7DF',
                            height: 20,
                            width: 20,
                            backgroundColor: {
                                image: require('../../../../assets/img/min-left.png')
                                // image:'http://qiniutlytest.4pis.com/cms/1660275099517企业微信截图_20220812113125.jpg'
                            }
                        }
                    }
                },
            })

            const option = {
                // backgroundColor: "#fff",
                title: titleArr,
                series: seriesArr
            }

            myChart.clear();
            myChart.setOption(option);
        }
    },
    created() { },
    async mounted() {
        await this.drawLine();
        this.timer = setInterval(async () => {
        await this.drawLine();
        }, this.intervalRefreshDate)

    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped>

</style>